/*
 * @Description: 收款报表
 * @Author: 李镇鹏
 * @Date: 2019-06-24 10:41:42
 * @LastEditTime: 2019-07-01 19:54:04
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import { message } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {post, config, transterQuery, postFrom} from '../../axios';
import { handleExportParams } from '../../utils';
import moment from "moment";
import {API_verify_findHsbPayOrderSplitAccountSumPage} from "../../axios/config";

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                buildingName: '',
                roomNo: '',
                projectName: '',
                merchantName: '',
                startDate: '',
                endDate: '',
                mustPayDate:'',
                customerKey:'',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableTotalMny: 0, //表格总金额,
            receivedMoney: 0, //已收金额
            historyBillMoney: 0,// 历史迁移金额
            uncollectedMoney: 0,// 未收金额
            showDetailModal: false, //显示详情
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            current = values.current
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true,current });

        postFrom({ url: config.API_verify_findHsbPayOrderSplitAccountSumPage, data }).then(res => {
            this.setState({ tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleDetail = (e, msg) => { //详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPack(msg);
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            tableTotalMny,
            historyBillMoney,
            uncollectedMoney,
            receivedMoney,
            showDetailModal,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column' }}>
                    <SuperForm
                        onRef={ref => this.superFormRef = ref}
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ handleDetail: this.handleDetail })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    historyBillMoney={historyBillMoney}
                    uncollectedMoney={uncollectedMoney}
                    receivedMoney={receivedMoney}
                    current={current}
                    onChange={this.handleSearch}
                />
            </PageWrap>
        )
    }
}

const searchData = () => {
    let data = [
        {
            tagName: 'DatePicker',
            formConfig: { name: 'startDate' },
            attribute: { placeholder: '请选择分账开始日期', style: { width: "170px" } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'endDate' },
            attribute: { placeholder: '请选择分账结束日期', style: { width: "170px" } },
        },

    ];
    return data;
};

const columns = ({ handleDetail }) => [
    {
        title: '分账日期',
        dataIndex: 'clrgDt',
        render(text, record, index) {
            return <span >
                <div>{record.clrgDt ? moment(record.clrgDt).format('YYYY-MM-DD') : null}</div>
            </span>
        }
    },
    {
        title: '分账交易流水号',
        dataIndex: 'clrgTxnSrlNo',
        render:(text,record)=>`${record.clrgTxnsrlno}`
    },
    {
        title: '商家编号',
        dataIndex: 'mktMrchId'
    },
    {
        title: '商家名称',
        dataIndex: 'mktMrchNm'
    },
    {
        title: '分账金额（元）',
        dataIndex: 'toClrgamt',
        render(text, record, index) {
                return <span>
                <div>{record.toClrgamt}</div>
                </span>
            }
    },
    {
        title: '分账状态代码',
        dataIndex: 'clrgStcd',
        render(text, record, index) {
                return <span>
                <div>{record.clrgStcd===2?'分账成功':'分账异常'}</div>
                </span>
        }
    },
    {
        title: '分账失败原因',
        dataIndex: 'rspInf',
    },

];


// WEBPACK FOOTER //
// ./src/page/HsbPaySplitAccountSum/index.js